// Initial data for each step - can be imported and combined in form configs

// Step 1: Suitability Check (no data needed)
export const criteriaStepInitialData = {};

// Step 1: Criteria with Selection Check
export const criteriaWithSelectionStepInitialData = {
  criteriaSelection: '',
};

// Step: Single Selection (generic - field names configured in stepConfig)
export const singleSelectionStepInitialData = {};

// Step 3: Business Information
export const abnLookupStepInitialData = {
  businessSearch: '',
  dataSource: undefined as 'autocomplete' | 'manual' | undefined,
  businessName: '',
  selectedABN: '',
  postcode: '',
  entityType: '',
  gstStatus: '',
};

// Step 4: Business Details & Metrics
export const businessDetailsStepInitialData = {
  industry: '',
  customIndustry: '',
  numberOfEmployees: '',
  numberOfSuppliers: '',
  numberOfCustomers: '',
  outstandingInvoiceValue: '',
  netAssets: '',
  annualTurnover: '',
  tradingName: '',
  countryOfRegistration: '',
  state: '',
  businessType: '',
};

// Step 5: Business Description
export const textFieldStepInitialData = {
  businessDescription: '',
};

// Step 6: Contact Details
export const contactDetailsStepInitialData = {
  title: '',
  firstName: '',
  lastName: '',
  phone: '',
  workEmail: '',
  howDidYouHear: '',
  message: '',
  termsAccepted: false,
  marketingConsent: false,
  creditReportConsent: false,
};

// Step: Multi Input (generic - field names configured in stepConfig)
export const multiInputStepInitialData = {};

// Step: Trust Details
export const trustDetailsStepInitialData = {
  trustType: '',
  trusteeType: '',
  trustAbnAcn: '',
  trusteeName: '',
  trustDirectorsEmail: '',
};

// Step: Checkbox List (generic - field names configured in stepConfig)
export const checkboxListStepInitialData = {};

// Helper function to combine step data - truly flexible approach
export function combineStepData(...stepDataArray: Record<string, unknown>[]): Record<string, unknown> {
  // Simply merge all step data without hardcoded defaults
  return stepDataArray.reduce((combined, stepData) => {
    return { ...combined, ...stepData };
  }, {});
}


